import { HeartBank } from "../../../managers/HeartBank.ts";
import template from "./hb-lockbox.mjs";
import { render } from "lit-html";
import { fs } from "../../../firebase.ts";
import { User } from "firebase/auth";
import {
    collection,
    getDocs,
    query,
    orderBy,
    updateDoc,
    onSnapshot
} from "firebase/firestore";
import { HbHeader } from "../../hb-header/hb-header.ts";
import { redirect, wait } from "../../global.ts";

import { Modal } from "flowbite";
import type { ModalOptions, ModalInterface } from "flowbite";
import type { InstanceOptions } from "flowbite";

export class HbLockbox extends HTMLElement {
    private heartbank: HeartBank = new HeartBank();
    private modal: ModalInterface;
    private header = document.querySelector("hb-header") as HbHeader;

    private lockbox: HTMLElement;
    private passkeys: HTMLElement;
    private add: HTMLButtonElement;
    private prove: HTMLAnchorElement;
    private message: HTMLParagraphElement;

    private passkeysCount = 0;

    constructor() {
        super();
        render(template(null), this);

        this.lockbox = this.querySelector("#hb-lockbox")!;
        this.passkeys = this.querySelector("#hb-lockbox-passkeys")!;
        this.add = this.querySelector("#hb-lockbox-add")!;
        this.prove = this.querySelector("#hb-lockbox-prove")!;
        this.message = this.querySelector("#hb-lockbox-message")!;

        const modalOptions: ModalOptions = {
            placement: "center",
            backdrop: "dynamic",
            backdropClasses:
                "bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-40",
            closable: true,
            onHide: () => {
                //window.location.hash = "#";
            },
            onShow: () => {
                //console.log("modal is shown");
            },
            onToggle: () => {
                //console.log("modal has been toggled");
            }
        };

        // instance options object
        const instanceOptions: InstanceOptions = {
            id: "hb-lockbox",
            override: true
        };

        this.modal = new Modal(this.lockbox, modalOptions, instanceOptions);
    }

    connectedCallback() {
        this.add.disabled = !this.heartbank.isPasskeySupported();
        this.add.addEventListener("click", this.addPasskey.bind(this));

        this.heartbank.addAuthStateListener((user) => {
            if (user) {
                this.render(user);
            }
        });

        // const passkeyQuery = query(
        //     collection(fs, "users", this.heartbank.user!.uid, "passkeys"),
        //     orderBy("name")
        // );
        // onSnapshot(passkeyQuery, (snapshot) => {
        //     //const keys = snapshot.docs.map((doc) => doc.data());
        //     this.render(this.heartbank.user!.uid);
        // });
    }

    private async addPasskey() {
        this.add.disabled = true;
        this.message.textContent = "Registering passkey...";
        this.message.style.color = "orange";

        const name =
            localStorage.getItem("passkey") ||
            prompt(
                "Please enter a name for your device:"
                //, navigator.userAgent // prefilled
            ); // this prompt might cauase document to lose focus: try to test this

        if (name) {
            //if (!document.hasFocus()) window.focus();
            const status = await this.heartbank.registerPasskey(name);
            this.message.textContent = status.text;
            this.message.style.color = status.color;
            if (this.passkeysCount === 0) {
                this.header.renderMenu();
                await wait(1); //if not good then refactor to onSnapshot
            }
            if (status.text.includes("focus"))
                localStorage.setItem("passkey", name);
            else localStorage.removeItem("passkey");
            this.render(this.heartbank.user);
            redirect("lockbox");
        } else {
            this.message.textContent = "";
        }

        this.add.disabled = false;
    }

    // allow revoking passkeys ?? yes bc passkey is used to confirm human; heartkey is used for signing!
    async render(user: User | null) {
        if (this.heartbank.isPasskeySupported() && user?.phoneNumber) {
            const keysQuery = query(
                collection(fs, "users", user.uid, "passkeys"),
                orderBy("name")
            );
            const keysSnap = await getDocs(keysQuery);
            this.passkeysCount = keysSnap.size;

            if (keysSnap.empty) {
                this.passkeys.innerHTML =
                    "<p class='p-3'>You have not registered any passkeys</p>";
                this.passkeys.style.color = "gray";
            } else {
                this.passkeys.innerHTML = "";
                this.passkeys.style.color = "";

                keysSnap.docs.forEach((doc, index) => {
                    const { name, createdAt } = doc.data();
                    const li = document.createElement("li");
                    li.classList.add(
                        "flex",
                        "items-center",
                        "justify-between",
                        index === this.passkeysCount - 1 ? "mb-0" : "mb-4",
                        "bg-white",
                        "dark:bg-gray-800",
                        "border",
                        "border-gray-200",
                        "dark:border-gray-700",
                        "shadow-sm",
                        "rounded-lg",
                        "p-4",
                        "text-lg",
                        "font-semibold",
                        "text-gray-900",
                        "dark:text-white"
                    );

                    const span = document.createElement("span");
                    //span.textContent = new Date(createdAt).toLocaleString();
                    span.innerHTML = "🔑&nbsp;&nbsp;" + name;
                    span.classList.add("cursor-pointer");
                    span.onclick = async () => {
                        const newName = prompt(
                            "New name for this passkey:",
                            name
                        )?.trim();
                        if (newName && newName !== name) {
                            await updateDoc(doc.ref, { name: newName });
                            this.message.textContent = `${name} has been renamed to ${newName}`;
                            this.message.style.color = "green";
                            this.render(user);
                            // cannot delete passkeys
                            // this.message.textContent =
                            //     "This passkey has been removed. Please delete it from your device as well.";
                            // this.message.style.color = "orange";
                        }
                    };

                    const revokeBtn = document.createElement("button");
                    revokeBtn.classList.add("cursor-pointer");
                    revokeBtn.textContent = "🗑️";
                    revokeBtn.onclick = async () => {
                        if (confirm(`Remove ${name} as your passkey?`)) {
                            //await deleteDoc(doc.ref);
                            const status = await this.heartbank.revokePasskey(
                                doc.ref.id
                            );
                            this.render(user);
                            this.message.textContent =
                                name +
                                " has been removed. Please delete this passkey from your device as well.";
                            this.message.style.color = "orange";
                        }
                    };

                    li.append(span, revokeBtn);
                    this.passkeys.appendChild(li);
                });
            }
            this.add.classList.remove("hidden");
            this.prove.classList.add("hidden");
        } else {
            this.passkeys.innerHTML = this.heartbank.isPasskeySupported()
                ? "<p class='p-3'>Only humans with a Heart of Mithril or above can create passkeys. Please prove your humanity by confirming your phone number.</p>"
                : "<p class='p-3'>Passkeys are not supported on this device.</p>";
            this.passkeys.style.color = "gray";
            this.add.classList.add("hidden");
            this.prove.classList.remove("hidden");
        }
    }

    show() {
        this.modal.show();
    }

    hide() {
        this.modal.hide();
    }
}
